
import { Component, Vue, Watch } from "vue-property-decorator";
import SubList from "./SubList.vue";
import { isEmptyOrWhiteSpace, isNull } from "@/utils/Common";
import { Fetcher as Ajax } from "@/utils/Request";
import { API_PATENT_TREE } from "@/configs/Apis";
import { TreeItemsSize } from "@/configs/Consts";

@Component({ components: { SubList } })
export default class MonitorWrapper extends Vue {
  $refs!: {
    subList: any
  };

  checkedStatus = "VALID";
  currentNavPath: string | "" = "";
  nodeQueryData = "";

  componentName = "Monitor";

  treeData: any = null;
  openedMenus: Array<any> = [];

  get showFeeStandard() {
    const level = this.$store.getters["user/user"].level;
    return level === "TRIAL" || level === "FORMAL" || level === "CHANNEL" || level === "VIP" || level === "ULTIMATE" || level === "ADMIN";
  }

  get showMyPatentOperation() {
    const level = this.$store.getters["user/user"].level;
    return level === "TRIAL" || level === "FORMAL" /** || level === "CHANNEL" */ || level === "VIP" || level === "ULTIMATE" || level === "ADMIN";
  }

  async loadPatentTree() {
    const data = await Ajax.queryData(API_PATENT_TREE, { patentStatus: this.checkedStatus }, "GET", false);
    const summary = data[0];
    let count = 0;
    summary.children.forEach((child: any) => {
      count += child.count;
    });
    summary.children.push({ title: "全部", count: count, patentFilter: { patentStatus: "" } });
    const tree = data.slice(1);

    const showCount = TreeItemsSize;

    tree.forEach((item: any) => {
      if (isNull(item.children)) {
        return;
      }
      if (item.children.length <= showCount) {
        item.showData = { data: [].concat(item.children) };
      } else {
        item.showData = { index: 0, size: showCount, data: item.children.slice(0, showCount) };
      }
    });
    this.treeData = { summary, tree };
  }

  onDataSelect(node: any) {
    if (this.checkedStatus === node.patentFilter.patentStatus) {
      this.onCheckedStatusChanged();
      if (this.$refs.subList) {
        this.$refs.subList.reloadData();
      }
    } else {
      this.checkedStatus = node.patentFilter.patentStatus;
    }
  }

  onTreeNodeClick(index: string) {
    let nodeData: any = {};
    this.currentNavPath = index;
    if (!isEmptyOrWhiteSpace(index) && index !== "feeStandard" && index !== "patentOperation") {
      const parts = index.split("-");
      if (parts.length === 1) {
        nodeData = this.treeData.tree[parts[0]];
      } else {
        nodeData = this.treeData.tree[parts[0]].children[parts[1]];
      }
      if (!nodeData || !nodeData.patentFilter) {
        return;
      }
      const filter = nodeData.patentFilter;
      if (filter.unfollow) {
        this.componentName = "UnfollowPatents";
        this.nodeQueryData = "";
        return;
      } else {
        if (this.componentName !== "Monitor") {
          this.componentName = "Monitor";
        }
      }
    } else if (index === "feeStandard") {
      this.componentName = "FeeStandard";
      nodeData.patentFilter = "";
    } else if (index === "patentOperation") {
      this.componentName = "MyPatentOperationList";
      nodeData.patentFilter = "";
    }

    this.nodeQueryData = JSON.stringify(nodeData.patentFilter) || "";
  }

  loadMoreData(item: any) {
    const showData = item.showData;
    if (isNull(showData)) {
      return;
    }
    const index = showData.index + 1;
    const start = index * showData.size;
    let end = start + showData.size;
    if (end > item.children.length) {
      end = item.children.length;
    }
    showData.index = index;
    showData.data = [].concat(showData.data, item.children.slice(start, end));
  }

  @Watch("checkedStatus")
  onCheckedStatusChanged() {
    this.currentNavPath = "";
    this.openedMenus = [];
    if (this.treeData) {
      this.treeData.tree = null;
    }
    this.nodeQueryData = "";
    if (this.componentName !== "Monitor") {
      this.componentName = "Monitor";
    } else {
      this.loadPatentTree();
    }
  }
}
